import React from 'react';
import styled from 'styled-components';
import { Divider } from 'styled_components/Common/Divider';

const StatusDisplayStyle = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	padding: 15px;
	background: ${props => props.theme.white};
	color: ${props => props.theme.defaultFontColor};

	.row {
		display: flex;
		align-items: center;
		position: relative;
		height: 40px;
		.label {
			width: 100px;
		}
	}

	.value {
		display: flex;
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		.row {
			height: 52px;
			.label {
				width: 150px;
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		padding: 20px;
		.row {
			height: 80px;
			.label {
				width: 150px;
			}
		}
	}
`;

export const StatusDisplay = ({ id }) => {
	return (
		<StatusDisplayStyle
			id={`split-info-display-${id}`}
			className='status-display'
			data-cy='status-display'
		>
			<div className='row'>
				<div className='label labels21'>All Locations</div>
				<div className='value'>
					<div className='amount body10'>20.35</div>
					<div className='unit body10'>kW</div>
				</div>
			</div>
			<div className='row'>
				<Divider />
				<div className='label labels21'>Greenville</div>
				<div className='value'>
					<div className='amount body10'>12.1</div>
					<div className='unit body10'>kW</div>
				</div>
			</div>
			<div className='row'>
				<Divider />
				<div className='label labels21'>Birmingham</div>
				<div className='value'>
					<div className='amount body10'>6.21</div>
					<div className='unit body10'>kW</div>
				</div>
			</div>
			<div className='row'>
				<Divider />
				<div className='label labels21'>Chattanooga</div>
				<div className='value'>
					<div className='amount body10'>2</div>
					<div className='unit body10'>kW</div>
				</div>
			</div>
		</StatusDisplayStyle>
	);
};
